export default __webpack_public_path__ + "static/media/404.4c2498e8.svg";